(function () {
  "use strict";

  /*
   * ミールセット対象Variant ID
   */
  const MEAL_VARIANT_IDS = [
    "45240853430454",
    "45240853463222",
    "45240853397686",
    "45240853528758",
    "45240853627062",
    "45240853561526",
    "45240853594294",
    "45240853790902",
    "45240853659830",
    "45240853692598",
    "45240853725366",
    "45240853823670",
    "45240853856438",
    "45240853889206",
    "45240853921974",
    "45240853954742",
    "45240853987510",
    "45240854020278",
    "45240854053046",
    "45240854118582",
    "45240854085814",
    "45240854151350",
    "45240854184118",
    "45240854249654"
  ];

  /*
   * 各種サプリメント対象Variant ID
   */
  const SUPPLEMENT_VARIANT_IDS = [
    "45098540662966",
    "45098540695734",
    "45098540630198"
  ];

  const TARGET_PATH_PREFIX =
    "/apps/floor-s/subscription";

  /*
   * 日付の変更前の値を保存する属性
   */
  const ORIGINAL_ATTR =
    "data-mht-original-value";

  /*
   * 数量変更リンクの変更前のdisplayを保存する属性
   */
  const HIDDEN_QUANTITY_CHANGE_ATTR =
    "data-mht-hidden-quantity-change";

  const NOTICE_CLASS =
    "mht-delivery-locked-message";

  const RETRY_INTERVAL_MS = 800;
  const MAX_RETRIES = 8;

  const MUTATION_RETRY_DELAY_MS = 100;
  const URL_WATCH_INTERVAL_MS = 500;

  /*
   * スキップ確定後、同一ページへ再遷移するまでの待機時間
   */
  const SKIP_REDIRECT_DELAY_MS = 6000;

  const SKIP_REDIRECT_FLAG_PREFIX =
    "mht-skip-redirect-done:";

  const PRODUCT_TYPE_MEAL =
    "meal";

  const PRODUCT_TYPE_SUPPLEMENT =
    "supplement";

  let lastUrl =
    location.href;

  let retryTimer =
    null;

  let retryCount =
    0;

  let skipHooked =
    false;

  let historyPatched =
    false;

  let navigationClickHooked =
    false;

  let isApplying =
    false;

  let mutationObserver =
    null;

  let mutationObservedTarget =
    null;

  let mutationRetryTimer =
    null;

  let urlWatchTimer =
    null;

  let skipRedirectTimer =
    null;

  function normalizeText(text) {
    return (text || "")
      .replace(/\u3000/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function isTargetPage() {
    return (
      window.location.pathname.indexOf(
        TARGET_PATH_PREFIX
      ) === 0
    );
  }

  function getRedirectFlagKey() {
    return (
      SKIP_REDIRECT_FLAG_PREFIX +
      location.pathname +
      location.search
    );
  }

  function clearRedirectFlag() {
    try {
      sessionStorage.removeItem(
        getRedirectFlagKey()
      );
    } catch (error) {
      // sessionStorageが利用できない場合は何もしない
    }
  }

  function markRedirectDone() {
    try {
      sessionStorage.setItem(
        getRedirectFlagKey(),
        "1"
      );
    } catch (error) {
      // sessionStorageが利用できない場合は何もしない
    }
  }

  function isRedirectDone() {
    try {
      return (
        sessionStorage.getItem(
          getRedirectFlagKey()
        ) === "1"
      );
    } catch (error) {
      return false;
    }
  }

  function parseJaDate(text) {
    const normalized =
      normalizeText(text);

    const match =
      normalized.match(
        /(\d{4})\/(\d{1,2})\/(\d{1,2})/
      );

    if (!match) {
      return null;
    }

    const year =
      Number(match[1]);

    const month =
      Number(match[2]);

    const day =
      Number(match[3]);

    const date =
      new Date(
        year,
        month - 1,
        day,
        0,
        0,
        0,
        0
      );

    /*
     * 存在しない日付を除外する
     */
    if (
      date.getFullYear() !== year ||
      date.getMonth() !== month - 1 ||
      date.getDate() !== day
    ) {
      return null;
    }

    return date;
  }

  function formatJaDate(date) {
    const year =
      date.getFullYear();

    const month =
      String(
        date.getMonth() + 1
      ).padStart(2, "0");

    const day =
      String(
        date.getDate()
      ).padStart(2, "0");

    return (
      year +
      "/" +
      month +
      "/" +
      day
    );
  }

  /*
   * ミールセット用の日付計算
   *
   * 火曜日から翌月曜日までを1期間とし、
   * その期間終了後の金曜日を返す
   *
   * 例：
   * 5/11（月）→ 5/15（金）
   * 5/12（火）→ 5/22（金）
   * 5/18（月）→ 5/22（金）
   */
  function calcMealDeliveryDate(
    billingDate
  ) {
    const billing =
      new Date(
        billingDate.getFullYear(),
        billingDate.getMonth(),
        billingDate.getDate(),
        0,
        0,
        0,
        0
      );

    const day =
      billing.getDay();

    /*
     * 月曜日なら当日を期間終了日とする。
     * 火曜日から日曜日なら次の月曜日を期間終了日とする。
     */
    const daysToMonday =
      day === 1
        ? 0
        : ((8 - day) % 7);

    const cycleEndMonday =
      new Date(billing);

    cycleEndMonday.setDate(
      billing.getDate() +
      daysToMonday
    );

    cycleEndMonday.setHours(
      0,
      0,
      0,
      0
    );

    /*
     * 月曜日の4日後が金曜日
     */
    const deliveryDate =
      new Date(
        cycleEndMonday
      );

    deliveryDate.setDate(
      cycleEndMonday.getDate() + 4
    );

    deliveryDate.setHours(
      0,
      0,
      0,
      0
    );

    return deliveryDate;
  }

  /*
   * 各種サプリメント用の日付計算
   *
   * 水曜日から翌火曜日までを1期間とし、
   * その期間終了後の金曜日を返す
   *
   * 火曜日：
   * 同じ週の金曜日
   *
   * 水曜日から翌月曜日：
   * 翌週の金曜日
   */
  function calcSupplementDeliveryDate(
    billingDate
  ) {
    const billing =
      new Date(
        billingDate.getFullYear(),
        billingDate.getMonth(),
        billingDate.getDate(),
        0,
        0,
        0,
        0
      );

    const day =
      billing.getDay();

    /*
     * 火曜日なら当日を期間終了日とする。
     * 水曜日から月曜日なら次の火曜日を期間終了日とする。
     */
    const daysToTuesday =
      day === 2
        ? 0
        : ((9 - day) % 7);

    const cycleEndTuesday =
      new Date(billing);

    cycleEndTuesday.setDate(
      billing.getDate() +
      daysToTuesday
    );

    cycleEndTuesday.setHours(
      0,
      0,
      0,
      0
    );

    /*
     * 火曜日の3日後が金曜日
     */
    const deliveryDate =
      new Date(
        cycleEndTuesday
      );

    deliveryDate.setDate(
      cycleEndTuesday.getDate() + 3
    );

    deliveryDate.setHours(
      0,
      0,
      0,
      0
    );

    return deliveryDate;
  }

  function calcDeliveryDate(
    billingDate,
    productType
  ) {
    if (
      productType ===
      PRODUCT_TYPE_SUPPLEMENT
    ) {
      return calcSupplementDeliveryDate(
        billingDate
      );
    }

    return calcMealDeliveryDate(
      billingDate
    );
  }

  function getUpperNoticeText(
    productType
  ) {
    if (
      productType ===
      PRODUCT_TYPE_SUPPLEMENT
    ) {
      return "※【各種サプリメント】次回配送日は決済日が水曜日から翌火曜日までの場合、翌金曜日以降になります。";
    }

    return "※【ミールセット】次回配送日は決済日が火曜日から翌月曜日までの場合、翌金曜日以降になります。";
  }

  function getLowerNoticeText(
    productType
  ) {
    if (
      productType ===
      PRODUCT_TYPE_SUPPLEMENT
    ) {
      return "※【各種サプリメント】配送予定日は決済予定日が水曜日から翌火曜日までの場合、翌金曜日以降になります。";
    }

    return "※【ミールセット】配送予定日は決済予定日が火曜日から翌月曜日までの場合、翌金曜日以降になります。";
  }

  /*
   * ラベルと値がpタグ2個の構造を最初に探す。
   *
   * pタグの構造で見つからない場合は、
   * ラベル文字列と日付文字列から検索する。
   */
  function getTextRow(
    container,
    labelCandidates
  ) {
    if (!container) {
      return null;
    }

    const rows =
      Array.from(
        container.querySelectorAll(
          "div"
        )
      );

    for (
      const row of rows
    ) {
      const paragraphs =
        row.querySelectorAll(
          "p"
        );

      if (
        paragraphs.length < 2
      ) {
        continue;
      }

      const label =
        normalizeText(
          paragraphs[0].textContent
        );

      if (
        labelCandidates.includes(
          label
        )
      ) {
        return {
          row: row,
          labelEl: paragraphs[0],
          valueEl: paragraphs[1]
        };
      }
    }

    const labelElements =
      Array.from(
        container.querySelectorAll(
          "p, span, div, dt, dd, label, strong"
        )
      ).filter(
        function (element) {
          return (
            labelCandidates.includes(
              normalizeText(
                element.textContent
              )
            )
          );
        }
      );

    for (
      const labelElement of
      labelElements
    ) {
      let current =
        labelElement.parentElement;

      for (
        let depth = 0;
        current &&
        current !==
          container.parentElement &&
        depth < 6;
        depth += 1
      ) {
        const dateElements =
          Array.from(
            current.querySelectorAll(
              "p, span, div, dd, time"
            )
          ).filter(
            function (element) {
              if (
                element ===
                labelElement
              ) {
                return false;
              }

              const text =
                normalizeText(
                  element.textContent
                );

              return (
                /^\d{4}\/\d{1,2}\/\d{1,2}$/.test(
                  text
                )
              );
            }
          );

        if (
          dateElements.length > 0
        ) {
          const valueElement =
            dateElements.sort(
              function (a, b) {
                return (
                  a.children.length -
                  b.children.length
                );
              }
            )[0];

          return {
            row: current,
            labelEl: labelElement,
            valueEl: valueElement
          };
        }

        if (
          current === container
        ) {
          break;
        }

        current =
          current.parentElement;
      }
    }

    return null;
  }

  function setOriginalIfNeeded(
    element
  ) {
    if (
      !element.hasAttribute(
        ORIGINAL_ATTR
      )
    ) {
      element.setAttribute(
        ORIGINAL_ATTR,
        normalizeText(
          element.textContent
        )
      );
    }
  }

  function restoreOriginalIfNeeded(
    container,
    deliveryLabels
  ) {
    const row =
      getTextRow(
        container,
        deliveryLabels
      );

    if (!row) {
      return;
    }

    const original =
      row.valueEl.getAttribute(
        ORIGINAL_ATTR
      );

    if (original) {
      row.valueEl.textContent =
        original;

      row.valueEl.removeAttribute(
        ORIGINAL_ATTR
      );
    }
  }

  function ensureNotice(
    container,
    text
  ) {
    if (!container) {
      return;
    }

    let notice =
      container.querySelector(
        "." + NOTICE_CLASS
      );

    if (!notice) {
      notice =
        document.createElement(
          "p"
        );

      notice.className =
        NOTICE_CLASS;

      notice.style.marginTop =
        "12px";

      notice.style.fontSize =
        "14px";

      notice.style.lineHeight =
        "1.6";

      notice.style.whiteSpace =
        "pre-line";

      notice.style.color =
        "#666";

      container.appendChild(
        notice
      );
    }

    if (
      notice.textContent !== text
    ) {
      notice.textContent =
        text;
    }
  }

  function removeNotices(
    container
  ) {
    if (!container) {
      return;
    }

    container
      .querySelectorAll(
        "." + NOTICE_CLASS
      )
      .forEach(
        function (element) {
          element.remove();
        }
      );
  }

  /*
   * 上側の「準備／配送中」ブロックを取得する
   */
  function findUpperBlock() {
    const deliveryLabels =
      Array.from(
        document.querySelectorAll(
          "p, span, div, dt, dd, label, strong"
        )
      ).filter(
        function (element) {
          return (
            normalizeText(
              element.textContent
            ) === "次回配送日"
          );
        }
      );

    for (
      const deliveryLabel of
      deliveryLabels
    ) {
      let current =
        deliveryLabel.parentElement;

      for (
        let depth = 0;
        current &&
        current !== document.body &&
        depth < 10;
        depth += 1
      ) {
        const text =
          normalizeText(
            current.textContent
          );

        const hasDeliveryDate =
          text.indexOf(
            "次回配送日"
          ) !== -1;

        const hasBillingDate =
          text.indexOf(
            "決済日"
          ) !== -1;

        const dates =
          text.match(
            /\d{4}\/\d{1,2}\/\d{1,2}/g
          ) || [];

        if (
          hasDeliveryDate &&
          hasBillingDate &&
          dates.length >= 2
        ) {
          return current;
        }

        current =
          current.parentElement;
      }
    }

    /*
     * STG構造用の予備判定
     */
    const candidates =
      Array.from(
        document.querySelectorAll(
          "div"
        )
      ).filter(
        function (element) {
          const text =
            normalizeText(
              element.textContent
            );

          return (
            text.indexOf(
              "準備/配送中"
            ) !== -1 &&
            text.indexOf(
              "決済済み"
            ) !== -1 &&
            text.indexOf(
              "次回配送日"
            ) !== -1 &&
            text.indexOf(
              "決済日"
            ) !== -1
          );
        }
      );

    if (
      candidates.length === 0
    ) {
      return null;
    }

    return candidates.sort(
      function (a, b) {
        return (
          normalizeText(
            a.innerText || ""
          ).length -
          normalizeText(
            b.innerText || ""
          ).length
        );
      }
    )[0];
  }

  function findLowerBlock() {
    return document.querySelector(
      "#mikawaya-subscription-lines-delivery-plan"
    );
  }

  /*
   * Floor-sの定期詳細表示領域を取得する
   */
  function getFloorSRoot() {
    if (!isTargetPage()) {
      return null;
    }

    const lowerBlock =
      findLowerBlock();

    if (lowerBlock) {
      const explicitRoot =
        lowerBlock.closest(
          "#mikawaya-subscription, " +
          "[id^='mikawaya-subscription-root'], " +
          "[id^='mikawaya-subscription-detail'], " +
          "[class*='mikawaya-subscription']"
        );

      if (explicitRoot) {
        return explicitRoot;
      }

      let current =
        lowerBlock;

      for (
        let depth = 0;
        current &&
        current.parentElement &&
        current.parentElement !==
          document.body &&
        depth < 5;
        depth += 1
      ) {
        current =
          current.parentElement;

        const text =
          normalizeText(
            current.textContent
          );

        if (
          text.indexOf(
            "配送予定日"
          ) !== -1 &&
          (
            text.indexOf(
              "次回配送日"
            ) !== -1 ||
            text.indexOf(
              "定期コース"
            ) !== -1
          )
        ) {
          return current;
        }
      }

      return (
        lowerBlock.parentElement ||
        lowerBlock
      );
    }

    const upperBlock =
      findUpperBlock();

    if (upperBlock) {
      return upperBlock;
    }

    return null;
  }

  function getCurrentDetailScope() {
    return getFloorSRoot();
  }

  /*
   * 現在の契約の商品種別を判定する
   *
   * 戻り値：
   * meal
   * supplement
   * null
   */
  function getCurrentProductType(
    scope
  ) {
    if (
      !isTargetPage() ||
      !scope
    ) {
      return null;
    }

    const searchRoot =
      scope.cloneNode(
        true
      );

    searchRoot
      .querySelectorAll(
        "script, style, noscript"
      )
      .forEach(
        function (element) {
          element.remove();
        }
      );

    const html =
      searchRoot.innerHTML || "";

    const mealMatched =
      MEAL_VARIANT_IDS.some(
        function (variantId) {
          return (
            html.indexOf(
              variantId
            ) !== -1
          );
        }
      );

    const supplementMatched =
      SUPPLEMENT_VARIANT_IDS.some(
        function (variantId) {
          return (
            html.indexOf(
              variantId
            ) !== -1
          );
        }
      );

    if (
      mealMatched &&
      !supplementMatched
    ) {
      return PRODUCT_TYPE_MEAL;
    }

    if (
      supplementMatched &&
      !mealMatched
    ) {
      return PRODUCT_TYPE_SUPPLEMENT;
    }

    if (
      mealMatched &&
      supplementMatched
    ) {
      console.warn(
        "[mht] ミールセットとサプリメントのVariant IDが同一画面内で検出されました。"
      );
    }

    return null;
  }

  function transformUpperBlock(
    container,
    productType
  ) {
    if (
      !container ||
      !productType
    ) {
      return false;
    }

    const billingRow =
      getTextRow(
        container,
        ["決済日"]
      );

    const deliveryRow =
      getTextRow(
        container,
        ["次回配送日"]
      );

    if (
      !billingRow ||
      !deliveryRow
    ) {
      return false;
    }

    const billingDate =
      parseJaDate(
        billingRow.valueEl
          .textContent
      );

    if (!billingDate) {
      return false;
    }

    const calculatedText =
      formatJaDate(
        calcDeliveryDate(
          billingDate,
          productType
        )
      );

    setOriginalIfNeeded(
      deliveryRow.valueEl
    );

    if (
      normalizeText(
        deliveryRow.valueEl
          .textContent
      ) !== calculatedText
    ) {
      deliveryRow.valueEl.textContent =
        calculatedText;
    }

    ensureNotice(
      container,
      getUpperNoticeText(
        productType
      )
    );

    return true;
  }

  function transformLowerBlock(
    container,
    productType
  ) {
    if (
      !container ||
      !productType
    ) {
      return false;
    }

    const billingRow =
      getTextRow(
        container,
        ["決済予定日"]
      );

    const deliveryRow =
      getTextRow(
        container,
        ["配送予定日"]
      );

    if (
      !billingRow ||
      !deliveryRow
    ) {
      return false;
    }

    const billingDate =
      parseJaDate(
        billingRow.valueEl
          .textContent
      );

    if (!billingDate) {
      return false;
    }

    const calculatedText =
      formatJaDate(
        calcDeliveryDate(
          billingDate,
          productType
        )
      );

    setOriginalIfNeeded(
      deliveryRow.valueEl
    );

    if (
      normalizeText(
        deliveryRow.valueEl
          .textContent
      ) !== calculatedText
    ) {
      deliveryRow.valueEl.textContent =
        calculatedText;
    }

    ensureNotice(
      container,
      getLowerNoticeText(
        productType
      )
    );

    return true;
  }

  /*
   * 画面内にあるすべての「数量」ラベルを取得する
   *
   * ミール・サプリ共通
   */
  function findAllQuantityLabels() {
    const floorSRoot =
      getFloorSRoot();

    if (!floorSRoot) {
      return [];
    }

    return Array.from(
      floorSRoot.querySelectorAll(
        "p, span, div, dt, dd, label, strong"
      )
    ).filter(
      function (element) {
        return (
          normalizeText(
            element.textContent
          ) === "数量"
        );
      }
    );
  }

  /*
   * 数量行の「変更」だけをすべて取得する
   *
   * 商品名横の「変更」は取得しない
   */
  function findAllQuantityChangeControls() {
    const floorSRoot =
      getFloorSRoot();

    if (!floorSRoot) {
      return [];
    }

    const quantityLabels =
      findAllQuantityLabels();

    const controls =
      [];

    quantityLabels.forEach(
      function (labelElement) {
        let current =
          labelElement.parentElement;

        for (
          let depth = 0;
          current &&
          current !==
            floorSRoot.parentElement &&
          depth < 6;
          depth += 1
        ) {
          const currentText =
            normalizeText(
              current.textContent
            );

          if (
            currentText.indexOf(
              "数量"
            ) !== -1
          ) {
            const changeControls =
              Array.from(
                current.querySelectorAll(
                  "a, button, [role='button']"
                )
              ).filter(
                function (control) {
                  const controlText =
                    normalizeText(
                      control.textContent ||
                      control.value ||
                      control.getAttribute(
                        "aria-label"
                      ) ||
                      ""
                    );

                  return (
                    controlText ===
                    "変更"
                  );
                }
              );

            if (
              changeControls.length > 0
            ) {
              changeControls.forEach(
                function (control) {
                  if (
                    !controls.includes(
                      control
                    )
                  ) {
                    controls.push(
                      control
                    );
                  }
                }
              );

              /*
               * 最初に見つかった最小の数量行で終了する。
               * 商品カード全体まで親を上がらないことで、
               * 商品名横の「変更」を対象外にする。
               */
              break;
            }
          }

          if (
            current === floorSRoot
          ) {
            break;
          }

          current =
            current.parentElement;
        }
      }
    );

    return controls;
  }

  /*
   * 数量行の「変更」だけをすべて非表示にする
   *
   * ミール・サプリ共通
   *
   * 「数量」と数量値「1」は残す
   */
  function hideAllQuantityChangeControls() {
    const controls =
      findAllQuantityChangeControls();

    if (
      controls.length === 0
    ) {
      return false;
    }

    controls.forEach(
      function (control) {
        if (
          !control.hasAttribute(
            HIDDEN_QUANTITY_CHANGE_ATTR
          )
        ) {
          control.setAttribute(
            HIDDEN_QUANTITY_CHANGE_ATTR,
            control.style.display ||
              ""
          );
        }

        /*
         * Mikawaya側のCSSに上書きされないように
         * 数量変更リンクだけdisplay:noneを設定する
         */
        control.style.setProperty(
          "display",
          "none",
          "important"
        );
      }
    );

    return true;
  }

  /*
   * 数量変更リンクを元に戻す
   */
  function restoreQuantityChangeControls(
    scope
  ) {
    if (!scope) {
      return;
    }

    scope
      .querySelectorAll(
        "[" +
          HIDDEN_QUANTITY_CHANGE_ATTR +
          "]"
      )
      .forEach(
        function (control) {
          const originalDisplay =
            control.getAttribute(
              HIDDEN_QUANTITY_CHANGE_ATTR
            );

          control.style.removeProperty(
            "display"
          );

          if (originalDisplay) {
            control.style.display =
              originalDisplay;
          }

          control.removeAttribute(
            HIDDEN_QUANTITY_CHANGE_ATTR
          );
        }
      );
  }

  function hideButtonsInScope(
    scope
  ) {
    if (!scope) {
      return;
    }

    scope
      .querySelectorAll(
        "button"
      )
      .forEach(
        function (button) {
          const text =
            normalizeText(
              button.textContent
            );

          if (
            text ===
              "配送日時を変更" ||
            text ===
              "定期コースを一時停止"
          ) {
            button.style.display =
              "none";
          }

          if (
            text === "スキップ"
          ) {
            button.style.display =
              "";
          }
        }
      );
  }

  function restoreButtonsInScope(
    scope
  ) {
    if (!scope) {
      return;
    }

    scope
      .querySelectorAll(
        "button"
      )
      .forEach(
        function (button) {
          const text =
            normalizeText(
              button.textContent
            );

          if (
            text ===
              "配送日時を変更" ||
            text ===
              "定期コースを一時停止" ||
            text ===
              "スキップ"
          ) {
            button.style.display =
              "";
          }
        }
      );
  }

  function restoreAll(
    scope
  ) {
    if (!scope) {
      return;
    }

    const upperBlock =
      findUpperBlock();

    const lowerBlock =
      findLowerBlock();

    restoreOriginalIfNeeded(
      upperBlock,
      ["次回配送日"]
    );

    restoreOriginalIfNeeded(
      lowerBlock,
      ["配送予定日"]
    );

    removeNotices(
      upperBlock
    );

    removeNotices(
      lowerBlock
    );

    restoreButtonsInScope(
      scope
    );

    restoreQuantityChangeControls(
      scope
    );
  }

  function pauseMutationObserver() {
    if (mutationObserver) {
      mutationObserver.disconnect();
    }

    mutationObservedTarget =
      null;
  }

  function resumeMutationObserver() {
    if (
      !mutationObserver ||
      !isTargetPage()
    ) {
      return;
    }

    const target =
      getFloorSRoot();

    if (!target) {
      mutationObserver.disconnect();

      mutationObservedTarget =
        null;

      return;
    }

    /*
     * SPA再描画でルート要素が差し替わった場合、
     * 新しいFloor-s領域へ監視を付け直す
     */
    if (
      mutationObservedTarget !==
      target
    ) {
      mutationObserver.disconnect();

      mutationObservedTarget =
        target;
    }

    mutationObserver.observe(
      target,
      {
        childList: true,
        subtree: true
      }
    );
  }

  function tryApply() {
    /*
     * Floor-s対象外ページでは処理しない
     */
    if (!isTargetPage()) {
      pauseMutationObserver();

      return true;
    }

    if (isApplying) {
      return false;
    }

    isApplying =
      true;

    pauseMutationObserver();

    try {
      const scope =
        getCurrentDetailScope();

      if (!scope) {
        return false;
      }

      const productType =
        getCurrentProductType(
          scope
        );

      if (!productType) {
        restoreAll(
          scope
        );

        return true;
      }

      hideButtonsInScope(
        scope
      );

      /*
       * ミール・サプリ共通で、
       * 数量行の「変更」のみを全件非表示にする
       */
      const quantityControlDone =
        hideAllQuantityChangeControls();

      const upperDone =
        transformUpperBlock(
          findUpperBlock(),
          productType
        );

      const lowerDone =
        transformLowerBlock(
          findLowerBlock(),
          productType
        );

      return (
        upperDone ||
        lowerDone ||
        quantityControlDone
      );
    } catch (error) {
      console.error(
        "[mht] tryApply error:",
        error
      );

      return false;
    } finally {
      isApplying =
        false;

      resumeMutationObserver();
    }
  }

  function stopRetry() {
    if (retryTimer) {
      clearTimeout(
        retryTimer
      );

      retryTimer =
        null;
    }
  }

  function scheduleRetry() {
    stopRetry();

    retryCount =
      0;

    function loop() {
      const done =
        tryApply();

      retryCount +=
        1;

      if (
        done ||
        retryCount >= MAX_RETRIES
      ) {
        stopRetry();

        return;
      }

      retryTimer =
        setTimeout(
          loop,
          RETRY_INTERVAL_MS
        );
    }

    loop();
  }

  /*
   * DOM監視はFloor-sの定期詳細領域だけに限定する
   */
  function observePageChanges() {
    if (!mutationObserver) {
      mutationObserver =
        new MutationObserver(
          function (mutations) {
            if (
              isApplying ||
              !isTargetPage()
            ) {
              return;
            }

            const hasChildListChange =
              mutations.some(
                function (mutation) {
                  return (
                    mutation.type ===
                      "childList" &&
                    (
                      mutation
                        .addedNodes
                        .length > 0 ||
                      mutation
                        .removedNodes
                        .length > 0
                    )
                  );
                }
              );

            if (
              !hasChildListChange
            ) {
              return;
            }

            if (
              mutationRetryTimer
            ) {
              clearTimeout(
                mutationRetryTimer
              );
            }

            mutationRetryTimer =
              setTimeout(
                function () {
                  mutationRetryTimer =
                    null;

                  scheduleRetry();
                },
                MUTATION_RETRY_DELAY_MS
              );
          }
        );
    }

    resumeMutationObserver();
  }

  function hardNavigateSamePage() {
    const url =
      new URL(
        window.location.href
      );

    url.searchParams.set(
      "mht_r",
      Date.now().toString()
    );

    console.log(
      "[mht] redirect to:",
      url.toString()
    );

    window.location.href =
      url.toString();
  }

  /*
   * 従来どおりのスキップ後処理
   *
   * スキップ時の再表示対策として追加した、
   * 100ms・600ms・1500ms・2500ms・5000ms等の
   * 追加リトライは含めていない
   */
  function schedulePostSkipRetryAndRedirect() {
    const delays = [
      300,
      1000,
      2000,
      3500
    ];

    delays.forEach(
      function (delay) {
        setTimeout(
          function () {
            tryApply();
          },
          delay
        );
      }
    );

    if (skipRedirectTimer) {
      clearTimeout(
        skipRedirectTimer
      );
    }

    skipRedirectTimer =
      setTimeout(
        function () {
          skipRedirectTimer =
            null;

          if (
            isRedirectDone()
          ) {
            return;
          }

          markRedirectDone();
          hardNavigateSamePage();
        },
        SKIP_REDIRECT_DELAY_MS
      );
  }

  function onUrlChange() {
    if (
      location.href === lastUrl
    ) {
      return;
    }

    lastUrl =
      location.href;

    clearRedirectFlag();

    if (!isTargetPage()) {
      stopRetry();
      pauseMutationObserver();

      return;
    }

    observePageChanges();
    scheduleRetry();

    setTimeout(
      function () {
        scheduleRetry();
      },
      500
    );

    setTimeout(
      function () {
        scheduleRetry();
      },
      1500
    );
  }

  function patchHistoryMethods() {
    if (historyPatched) {
      return;
    }

    const rawPushState =
      history.pushState;

    const rawReplaceState =
      history.replaceState;

    history.pushState =
      function () {
        const result =
          rawPushState.apply(
            this,
            arguments
          );

        onUrlChange();

        return result;
      };

    history.replaceState =
      function () {
        const result =
          rawReplaceState.apply(
            this,
            arguments
          );

        onUrlChange();

        return result;
      };

    window.addEventListener(
      "popstate",
      onUrlChange
    );

    historyPatched =
      true;
  }

  function startUrlWatcher() {
    if (urlWatchTimer) {
      return;
    }

    urlWatchTimer =
      setInterval(
        function () {
          if (
            location.href ===
            lastUrl
          ) {
            return;
          }

          onUrlChange();
        },
        URL_WATCH_INTERVAL_MS
      );
  }

  /*
   * 通常クリック監視はFloor-s領域内だけに限定する
   */
  function hookNavigationClicks() {
    if (
      navigationClickHooked
    ) {
      return;
    }

    document.addEventListener(
      "click",
      function (event) {
        if (!isTargetPage()) {
          return;
        }

        const element =
          event.target instanceof
          Element
            ? event.target
            : null;

        if (!element) {
          return;
        }

        const clickable =
          element.closest(
            "a, button, [role='button']"
          );

        if (!clickable) {
          return;
        }

        const floorSRoot =
          getFloorSRoot();

        if (
          !floorSRoot ||
          !floorSRoot.contains(
            clickable
          )
        ) {
          return;
        }

        scheduleRetry();

        setTimeout(
          function () {
            scheduleRetry();
          },
          100
        );

        setTimeout(
          function () {
            scheduleRetry();
          },
          500
        );

        setTimeout(
          function () {
            scheduleRetry();
          },
          1500
        );
      },
      true
    );

    navigationClickHooked =
      true;
  }

  /*
   * モーダル内のスキップ確定ボタンを監視する
   */
  function hookSkipButton() {
    if (skipHooked) {
      return;
    }

    document.addEventListener(
      "click",
      function (event) {
        if (!isTargetPage()) {
          return;
        }

        const element =
          event.target instanceof
          Element
            ? event.target
            : null;

        if (!element) {
          return;
        }

        const clickable =
          element.closest(
            'button, [role="button"], input[type="button"], input[type="submit"], a'
          );

        if (!clickable) {
          return;
        }

        const text =
          normalizeText(
            clickable.textContent ||
            clickable.value ||
            clickable.getAttribute(
              "aria-label"
            ) ||
            ""
          );

        if (
          text !== "スキップ"
        ) {
          return;
        }

        const modalLikeParent =
          clickable.closest(
            '[role="dialog"], ' +
            '[aria-modal="true"], ' +
            ".modal, " +
            ".ReactModal__Content, " +
            ".chakra-modal__content, " +
            ".chakra-modal__dialog-container"
          );

        if (
          !modalLikeParent
        ) {
          return;
        }

        schedulePostSkipRetryAndRedirect();
      },
      true
    );

    skipHooked =
      true;
  }

  function init() {
    console.log(
      "[mht] subscription control initialized"
    );

    clearRedirectFlag();

    patchHistoryMethods();
    hookSkipButton();
    hookNavigationClicks();
    startUrlWatcher();

    if (isTargetPage()) {
      observePageChanges();
      scheduleRetry();
    }
  }

  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      init
    );
  } else {
    init();
  }
})();